import LottieView from './LottieView';

export default LottieView;
export type { LottieViewProps } from './types';
export type { LottieViewRef } from './types';
